import { get } from "lodash";
import { OnlineItemBaseController } from "./online-item-base.controller";
import { onlineT } from "../../typings/online";
import { paymentT } from "../../typings/payment";
import { setPaymentsDeposit } from "../../utils/payment";

export class PastOnlineItemController extends OnlineItemBaseController {
    public static $inject: string[] = [
        "$element",
        "$scope",
        "categoryService",
        "localeNumber",
        "mediaGalleryService",
        "onlineItemEdit",
        "onlineItemService",
        "paymentService",
        "utilsService"
    ];

    // Binded
    public pastItemStatus: string;
    public containerEndDate: string;
    public containerId: number;
    public contractId: number;
    public getItems: Function;
    public saleDepositAmount: number;
    public salePaymentDeposit: paymentT.Payment[];

    public lastBidAmount: number;
    public lastBidder: onlineT.LastBidder;
    public isItemSold: boolean;

    public depositStateLabel;
    public paymentsDepositAmount: number;

    protected readOnly: boolean = true;

    private pastItemStatusEnum = onlineT.past.ItemStatus;

    constructor(
        protected $element: JQLite,
        protected $scope: ng.IScope,
        protected _categoryService,
        public localeNumber,
        protected mediaGalleryService,
        protected onlineItemEdit,
        private onlineItemService,
        public paymentService,
        public utilsService
    ) {
        super($element, $scope, _categoryService, mediaGalleryService, onlineItemEdit);
    }

    public $onInit() {
        this.isItemSold = this.pastItemStatus === this.pastItemStatusEnum.UNPAID ||
            this.pastItemStatus === this.pastItemStatusEnum.PAID;
        this.lastBidAmount = get(this.item, "pricing.last_bid.amount");
        this.lastBidder = this.onlineItemService.getLastBidder(this.item);

        const userId = this.item.pricing?.last_bid?.user_id;
        const paymentsDeposit = setPaymentsDeposit(userId, this.item.payment, this.salePaymentDeposit);
        this.depositStateLabel = this.paymentService.getDepositStateLabel(paymentsDeposit);
        this.paymentsDepositAmount = this.localeNumber.sumNbrs(paymentsDeposit.map(p => Number(p.amount)));

        this._watchInView();
    }
}
